import styles from "./Connector.module.css";
import GetSelectedStatusColor from "../constant/SelectedstatusColor";
import GetStatusColor from "../constant/statusColor";

const ConnectorContainer = ({
  OuterCard,
  containerIndex,
  selectedConnector,
  setSelectedConnector,
  setCardClicked,
  connector_types,
  setConnectorid,
  setChargerId,
  setDisplayid,
}) => {
  const handleCardClick = (
    status,
    index,
    connectorId,
    chargerId,
    displayId
  ) => {
    if (status !== "Available" && status !== "Gun Connected") return;
    setSelectedConnector({ containerIndex, connectorIndex: index });
    setCardClicked(true);
    setConnectorid(connectorId);
    setChargerId(chargerId);
    setDisplayid(displayId);
  };

  return (
    <div className={styles.stationOuterCard}>
      <p className={styles.stationCardName}>{OuterCard.charger_name}</p>

      <div className={styles.stationCardInfo}>
        <span>{OuterCard.type}</span>
        <span className={styles.cardInfoSeprator}></span>
        <span>{OuterCard.power_rating}kW</span>
      </div>

      {OuterCard?.connectors?.map((connectorItem, index) => {
        const isSelected =
          selectedConnector.containerIndex === containerIndex &&
          selectedConnector.connectorIndex === index;

        const matchingImg = connector_types.find(
          (item) => item.connector_name === connectorItem.display_id
        );

        const ImageSrc = matchingImg?.connector_image_url;

        return (
          <div
            key={index}
            className={styles.connectorCards}
            onClick={() =>
              handleCardClick(
                connectorItem?.status_config?.status,
                index,
                connectorItem?.connector_id,
                OuterCard?.charger_id,
                connectorItem?.display_id
              )
            }
            style={{
              backgroundColor: isSelected ? "#101941" : "white",
            }}
          >
            <div>
              <p
                className={styles.gunNo}
                style={{
                  color: isSelected ? "white" : "#404767",
                }}
              >
                {connectorItem.name}
              </p>
              {isSelected ? (
                <GetSelectedStatusColor
                  status={connectorItem?.status_config?.status}
                />
              ) : (
                <GetStatusColor status={connectorItem.status_config?.status} />
              )}
            </div>

            <div className={styles.connectorSide}>
              <div
                className={styles.imageContainer}
                style={{
                  backgroundColor: isSelected ? "white" : "#E8E8EC",
                }}
              >
                <img src={ImageSrc} className={styles.ConnectorImages} />
              </div>

              <p style={{ color: isSelected ? "white" : "#404767" }}>
                {connectorItem.name}
              </p>
              <p style={{ color: isSelected ? "#B7BAC6" : "#70758D" }}>
                Upto {connectorItem.power_rating}kW
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ConnectorContainer;
